export const LogoMark = ({ size = 38 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#0A1E3C" />
        <path
            d="M32 15 C26.5 11.5 19 11.5 13 14 V47 C19 44 26.5 44 32 47.5 C37.5 44 45 44 51 47 V14 C45 11.5 37.5 11.5 32 15 Z"
            stroke="#F0B429"
            strokeWidth="2.5"
            strokeLinejoin="round"
        />
        <path d="M32 15 V47.5" stroke="#F0B429" strokeWidth="2.5" />
        <path
            d="M18 21 C21.5 20 25.5 20 28 21 M18 27 C21.5 26 25.5 26 28 27 M36 21 C39.5 20 43.5 20 46 21 M36 27 C39.5 26 43.5 26 46 27"
            stroke="#C5A059"
            strokeWidth="1.6"
            strokeLinecap="round"
        />
    </svg>
);

export const Logo = ({ compact = false, onDark = false }) => (
    <div className="flex items-center gap-3" data-testid="nav-brand-logo">
        <LogoMark size={compact ? 30 : 38} />
        <div className="leading-tight">
            <p
                className={`whitespace-nowrap font-display text-xs font-extrabold tracking-wide sm:text-base ${
                    onDark ? "text-white" : "text-navy-950"
                }`}
            >
                PREPARAZIONE <span className="text-gold">CONCORSI</span>
            </p>
            <p className={`hidden text-[10px] uppercase tracking-[0.24em] sm:block ${onDark ? "text-slate-400" : "text-slate-500"}`}>
                Materiale didattico indipendente
            </p>
        </div>
    </div>
);
